import React from "react";

import { FormGroup, Switch } from "@mui/material";

import MouseOverPopover from "components/MouseOverPopover";

import HelpPopoverCard from "../HelpPopoverCard";

export const CreatePixelTrackingHelp = ({ language }) => (
    <HelpPopoverCard
        description={
            language?.popover?.create_pixel_tracking_popover ??
            "It is essentially asking whether you'd like to activate additional tracking through SignalSight on the browser side, besides the server-side event tracking you might already have set up. If you choose to enable it, SignalSight will track user interactions directly in the browser; if not, it will only send data from the server side."
        }
    />
);

/** "Enable pixel tracking at the browser level too?" switch. */
const CreatePixelToggle = ({ checked, onChange, language }) => (
    <FormGroup className="create_pixel_tracking_question mouse-over-popover-area mouse-over-popover-checkbox">
        <div style={{ maxWidth: "80%" }}>
            <span style={{ fontSize: "13px" }}>
                {language?.buttons?.create_pixel_tracking_question ??
                    "Do you want to enable pixel tracking at the browser level too?"}
            </span>
            <MouseOverPopover
                text={<CreatePixelTrackingHelp language={language} />}
            />
        </div>
        <Switch
            size="small"
            color="secondary"
            checked={checked}
            onChange={onChange}
        />
    </FormGroup>
);

export default CreatePixelToggle;
